export default __webpack_public_path__ + "static/media/gongan.0d590ea1.png";